import moment from "moment";
import { BaseMetadataType } from "../../../Core/Api/Types/base-metadata-type";
import { DbAssetObjectInfos } from "../../../Core/Api/Types/db-asset-object-infos";
import { DbCultureInfos } from "../../../Core/Api/Types/db-culture-infos";
import { EnrichedMetadata } from "../../../Core/Api/Types/enriched-metadata";
import { IDbBaseMetadataValueInfos } from "../../../Core/Api/Types/i-db-base-metadata-value-infos";
import { ObjectLayer } from "../../../Core/Api/Types/object-layer";
import { cacheService } from "../../../Core/Api/services";
import { CreateNewDbMetadataValue } from "../../../Core/Utils/asset-object-utils";
import { DbDeliveryBroadcasterInfos } from "../../../Core/Api/Types/db-delivery-broadcaster-infos";

export const getTitleAssetCultures = (assetObject: DbAssetObjectInfos, cultures: DbCultureInfos[]) => {
  const cultureIds: number[] = [];

  const { metadata } = assetObject;

  if (!assetObject.metadata || !metadata?.length) return [] as DbCultureInfos[];

  const localizedMeta = metadata.filter(
    (x) => x.value && x.value.length > 0 && (x.value[0].languageLocalizedCultureId > 0 || x.value[0].cultureId > 0)
    //&& x.fieldType !== BaseMetadataType.DbSynopsesMetadataValueInfos
  );
  if (!localizedMeta) return [] as DbCultureInfos[];
  for (let n = 0; n < localizedMeta.length; n++) {
    for (let i = 0; i < localizedMeta[n]?.value.length; i++) {
      if (
        localizedMeta[n].value[i].languageLocalizedCultureId &&
        !cultureIds.find((c) => c === localizedMeta[n].value[i].languageLocalizedCultureId)
      )
        cultureIds.push(localizedMeta[n].value[i].languageLocalizedCultureId);
      if (localizedMeta[n].value[i].cultureId && !cultureIds.find((c) => c === localizedMeta[n].value[i].cultureId))
        cultureIds.push(localizedMeta[n].value[i].cultureId);
    }
  }

  const objCultures = cultureIds.map((x) => cultures.find((y) => y.id === x)) || [];

  return objCultures as DbCultureInfos[];
};

export const getAssetCultures = (assetObject: DbAssetObjectInfos, cultures: DbCultureInfos[]) => {
  const cultureIds: number[] = [];

  const { metadata } = assetObject;

  if (!assetObject.metadata || !metadata?.length) return [] as DbCultureInfos[];

  const localizedMeta = metadata.filter(
    (x) =>
      x.value &&
      x.value.length > 0 &&
      (x.value[0].languageLocalizedCultureId > 0 || x.value[0].cultureId > 0) &&
      x.fieldType !== BaseMetadataType.DbSynopsesMetadataValueInfos
  );
  if (!localizedMeta) return [] as DbCultureInfos[];
  for (let n = 0; n < localizedMeta.length; n++) {
    for (let i = 0; i < localizedMeta[n]?.value.length; i++) {
      if (
        localizedMeta[n].value[i].languageLocalizedCultureId &&
        !cultureIds.find((c) => c === localizedMeta[n].value[i].languageLocalizedCultureId)
      )
        cultureIds.push(localizedMeta[n].value[i].languageLocalizedCultureId);
      if (localizedMeta[n].value[i].cultureId && !cultureIds.find((c) => c === localizedMeta[n].value[i].cultureId))
        cultureIds.push(localizedMeta[n].value[i].cultureId);
    }
  }
  const objCultures = cultureIds.map((x) => cultures.find((y) => y.id === x)) || [];

  return objCultures as DbCultureInfos[];
};

export const getMetadataCultures = (metadata: EnrichedMetadata[], cultures: DbCultureInfos[]) => {
  const cultureIds: number[] = [];

  if (!metadata || !metadata?.length) return [] as DbCultureInfos[];

  const localizedMeta = metadata.find(
    (x) =>
      x.value &&
      x.value.value &&
      x.value.value.length > 0 &&
      (x.value.value[0].languageLocalizedCultureId > 0 || x.value.value[0].cultureId > 0) &&
      x.field?.baseType !== BaseMetadataType.DbSynopsesMetadataValueInfos &&
      x.field?.baseType !== BaseMetadataType.DbCastsMetadataValueInfos
  );

  if (!localizedMeta) return [] as DbCultureInfos[];
  for (let i = 0; i < localizedMeta.value?.value.length; i++) {
    if (
      localizedMeta.value?.value[i] &&
      localizedMeta.value?.value[i]?.languageLocalizedCultureId &&
      !cultureIds.find((c) => c === localizedMeta.value?.value[i]?.languageLocalizedCultureId)
    )
      cultureIds.push(localizedMeta.value?.value[i].languageLocalizedCultureId);
    if (
      localizedMeta.value?.value[i] &&
      localizedMeta.value?.value[i]?.cultureId &&
      !cultureIds.find((c) => c === localizedMeta.value?.value[i]?.cultureId)
    )
      cultureIds.push(localizedMeta.value?.value[i].cultureId);
  }

  const objCultures = cultureIds.map((x) => cultures.find((y) => y.id === x)) || [];

  return objCultures as DbCultureInfos[];
};

export const getTitleType = (title: DbAssetObjectInfos | null) =>
  title?.metadata?.find((x) => x.fieldName === "titleType")?.value;

export const getGeneratedName = (selectedCultures: DbCultureInfos[], episode?: number) =>
  `${episode && episode > 0 ? `Episode ${episode} on ` : ""}${selectedCultures?.map((x) => x.englishName).join(", ")}`;

export const getBroacasterIdMetadata = (obj: DbAssetObjectInfos) => {
  const metadataId = cacheService.GetMetadata().find((x) => x.tagName === "broadcasterId")?.id;
  return obj.metadata?.find((x) => x.id === metadataId)?.value || -1;
};

export const getBroadcasterName = (broadcasterId: number, broadcasters: DbDeliveryBroadcasterInfos[]) =>
  broadcasters.find((x) => x.id === broadcasterId)?.name || "";

export const getBroadcasterImageSrc = (broadcasterId: number, broadcasters: DbDeliveryBroadcasterInfos[]) =>
  BROADCASTERS_ICONS_SRC[getBroadcasterName(broadcasterId, broadcasters)] || "";

export const getEpisodeMetadata = (obj: DbAssetObjectInfos) => {
  const metadataId = cacheService.GetMetadata().find((x) => x.tagName === "serieEpisodeNumberProduction")?.id;
  return obj.metadata?.find((x) => x.id === metadataId)?.value || -1;
};

export const getBundlesContent = (object: DbAssetObjectInfos) =>
  object.childObjects?.find((x) => x.name === "Bundles") || null;

export const getArtworksContent = (object: DbAssetObjectInfos) =>
  object.childObjects?.find((x) => x.name === "Artwork") || null;

export const generateArtworkCultureIdsMetadata = (selectedCultureIds: number[]) => {
  const artworkCultureIdsMetadataId = cacheService.GetMetadata().find((x) => x.tagName === "artworkCultureIds")?.id;
  if (!artworkCultureIdsMetadataId) return;
  return CreateNewDbMetadataValue(
    artworkCultureIdsMetadataId,
    BaseMetadataType.DbLongMultiMetadataValueInfos,
    "artworkCultureIds",
    selectedCultureIds
  );
};

export const generateLanguagePictureMetadata = (language: any) => {
  const languagePictureMetadataId = cacheService
    .GetMetadata()
    .find((x) => x.tagName === "languagePicture" && x.layer === ObjectLayer.Asset)?.id;
  if (!languagePictureMetadataId || !language) return;
  return CreateNewDbMetadataValue(
    languagePictureMetadataId,
    BaseMetadataType.DbLanguageCodeMetadataValueInfos,
    "languagePicture",
    language
  );
};

export const generateBroadcasterIdMetadata = (selectedPlatform: DbDeliveryBroadcasterInfos) => {
  const broadcasterMetadataId = cacheService.GetMetadata().find((x) => x.tagName === "broadcasterId")!.id;
  if (!broadcasterMetadataId || !selectedPlatform) return;
  return CreateNewDbMetadataValue(
    cacheService.GetMetadata().find((x) => x.tagName === "broadcasterId")!.id,
    BaseMetadataType.DbLongMetadataValueInfos,
    "broadcasterId",
    selectedPlatform!.id
  );
};

export const generateOrientationMetation = (orientation: string) => {
  const orientationMetadataId = cacheService.GetMetadata().find((x) => x.tagName === "contentSubType")?.id;
  if (!orientationMetadataId || !orientation) return;
  return CreateNewDbMetadataValue(
    orientationMetadataId,
    BaseMetadataType.DbStringMetadataValueInfos,
    "contentSubType",
    orientation
  );
};

export const getMetadataIsValid = (meta: IDbBaseMetadataValueInfos[]) => {
  for (let i = 0; i < meta.length; i++) {
    if (!metadataValueIsValid(meta[i])) return false;
  }
  return true;
};

export const metadataValueIsValid = (value: IDbBaseMetadataValueInfos) => {
  switch (value.fieldType) {
    case BaseMetadataType.DbCastsMetadataValueInfos:
      for (let i = 0; i < value.value.length; i++) {
        if (!value.value[i] || !value.value[i].lastname || !value.value[i].name || !value.value[i].function) {
          return false;
        }
      }
      break;
    case BaseMetadataType.DbLocalizedBoolMultiMetadataValueInfos:
      break;
    case BaseMetadataType.DbLocalizedTitlesMultiMetadataValueInfos:
      if (!value.value || value.value.length === 0) return false;
      for (let i = 0; i < value.value.length; i++) {
        if (!value.value[i] || !value.value[i].value) {
          return false;
        }
      }
      break;
    case BaseMetadataType.DbLocalizedCreditsMultiMetadataValueInfos:
      if (!value.value || value.value.length === 0) {
        return false;
      }
      for (let i = 0; i < value.value.length; i++) {
        if (!value.value[i] || !value.value[i].value) {
          return false;
        }
      }
      break;
    case BaseMetadataType.DbLocalizedDateTimeMultiMetadataValueInfos:
      if (!value.value || value.value.length === 0) {
        return false;
      }
      for (let i = 0; i < value.value.length; i++) {
        let date = moment(value.value[i].value);
        if ((date.year() === 1 && date.month() === 0 && date.day() === 1) || !date.isValid()) {
          return false;
        }
      }
      break;
    case BaseMetadataType.DbGenreMultiMetadataValueInfos:
      if (!value.value || value.value.length === 0) {
        return false;
      }
      for (let i = 0; i < value.value.length; i++) {
        if (!value.value[i] || !value.value[i].name) {
          return false;
        }
      }
      break;
    case BaseMetadataType.DbLocalizedRatingMultiMetadataValueInfos:
      if (!value.value || value.value.length === 0) {
        return false;
      }
      for (let i = 0; i < value.value.length; i++) {
        if (!value.value[i].values || !value.value[i].values || value.value[i].values.length === 0) {
          return false;
        }
      }
      break;
    case BaseMetadataType.DbSynopsesMetadataValueInfos:
      if (!value.value || value.value.length === 0) {
        return false;
      }
      for (let i = 0; i < value.value.length; i++) {
        if (!value.value[i] || !value.value[i].text) {
          return false;
        }
      }
      break;
    default:
      break;
  }
  return true;
};

export const BROADCASTERS_ICONS_SRC = {
  "The Roku Channel":
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAM1BMVEX///9mLZGLYKyfe7rGsNb18fhvOpeoiMF5R57YyuPPvdzs5PGylciVbrPi1+qCU6W8os9md90AAAAAmElEQVR4Aa3RBRLDMAxEUUWOzHT/yxblojfFHcqfeWH6z5absVkFAp11AoHOBwx0cQY8sx3ApgnIRJRYgwEgKloVARmFALHeA4LyCrRzGQSqVgdAmlaaghS9hnnxqZtsAy+0CYzQNog0BZzdzb+c/6whGgLSxjEAVBddAICyhhUAiLUKAslqdgBoXXQVACraTQAQO/mj328PS/8EwL+6oNYAAAAASUVORK5CYII=",
  "[BundleMaker] Google":
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAqFBMVEVHcEz7+/v+/v709PX////7+/v09fX4+Pj////8/Pz7+/v////z+PP29vf09PX////+/v7///////////83qlfrQzPsTkFHiPUlpkszf/RAhfX6uwD8wBLW4vyQs/j96N3/+vPh8eR8wJiHrfjylpBhuXftX0rR6Nb608j0qKNwofBKsGWzy/rzn5n0o57uc2/94J78zFb3u7es1rC6z/rHuTCVsC08ooagt3gtAAAAE3RSTlMA08Eb4kVwOqb5kV7jkn8NfnFw9v5R3wAAAVtJREFUOI2dU9lywjAMTIAchgmljU3sJBRycRZoocf//1ltyZ4cpi/dl0jeHWllxY7TxVPgecGT8weCkMQAEgaP6EncwcSShPEAYZ+fDHlZ5BG/P9T1YW8rRnhyYRoXzEeGn0G6XrKlBmNrOJppAVZnmpNftt1gDeSfVbhhwNa3W83Y1hh9aR1eFX/G43N/kjEYyCR/sGcdG4vvWb692jzYnKrgI88znL96RVQrlU3NJWdSgM5FihBv5sKHggSR9gW5FKx1BSGUSHwawQI8ZHl2B8FK4ZgmAjwspMDDKb4obc2nsgIEnrnpzTeltDF8lSbpsb1r2OWdS8Vpp8KiVAWgA+4TesSNFFBOm+bE+U8iqraD47gqJidVQ4NjA1eve4ydS6PgvGw3AfAxL0oOKAvM/fafi4z/YrcrTBx1/9q5vcj54N2QPk3sx+V3JMS3aKgSuUTCjR49zf/jF+G2OgtU1MugAAAAAElFTkSuQmCC",
  "[BundleMaker] Apple iTunes":
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAC5UlEQVR4Aa1XQ3hkQRjc+ynX2OZtbfu+tm3b1nlt27a9O4qNS5xxbdd+cTKvXydT31fJoPuvmvf6/ejw86dBlX6CwwQXCq6t5cLaz/xV4+ld6F8r9NdgsCAjIwf5+UUoLCwBydf8jN+JNQbBddzjDQM+gocErRSyWm2QgWu4lntq9/q01UAfwYKCgmK43W6ognu4lzEE+6oamCboLC0tR3vBGIwlOF2vgZm5uQWoqamBXrhcLpw5cxZ79uxFKxCxrGBMxpYZ6Eu33KAXNDp+/AQEBgbzv8Y6Kxi7+e1ofuAKVS/7zp27KE7i6dNnem5HAbVaM3CYh0YF/PWRkdEUpxHoQe3BPNTcQJCgTc9pT0tLh8VigdPpBLFv3368evVKBC7A16/fkJmZKX06qCXo39jAej67Wnjx4iVGjBiJ0NBwBAeHYsCAgTh48BCuXLmCKVOmIioqBrwS4eGRGDduPMxmMzyBWtRsbMCglWSePXuOkJAwCuhmnz79YLVaPSUrGjDWGQhgCvWEyspKdOrURUk8JiYO799/0Exg1KQ2DQxjHveEO3fuKomTPBcyUJPaNLCQxcQTNm3arGzAYDBABmoK7UU0sE7rAC5dukxJPCgoRPy6DMhATWpLDWzbtl35Cty//0DBgOQW3LhxU9nAsGEj4HA4dN0CySHkwvy6bKfECRMmISsrS34IZY8hMXnyFAZV5rFjx6WPoa5E9PnzZ2XxpKQUlJaWaiUik1IqXrBgkZKB06fPwBOKiv4fwA3Ni5FdK3NVVFSgd+++usRnzJilXIzII7JynJOTAxaa7t17Yt68+bh37z6+fPmKCxcuYvToMejVqzdWrVrNMi0rx4cVGxIFKDQkCi2ZAhRaMklTavWqeF6epCltxuneasvLyurb8lmqg0lfLw4m/dozmh0RtBUV6R/NuJZ7avf6eGs4ZeIwMoVmZrYcTvkZv+MarlUZTlUZIDi8diRfX8uFtZ8FqMb7Bx+2VJbBTrlcAAAAAElFTkSuQmCC",
  "[BundleMaker] Amazon":
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACjElEQVR4AbxVNXAcQRA8MyZmdmiIBLEZYrNz0yszU+TMSo2xmZmZmZmZ2WKm1nbt19Zqakt7+r9TV/Xj3UxPz8xeQBAAOisuV3yF+PBEcaFih8AGgMGKb9F8oJCBpvKmJi8qKsK9e/cM79+/jx8/fqQioi0FrEBIHDx0COPGj0frNm0MW1mf+R+vaQLmBWGqZ8UMbpJ5uHTpUoTEPQrwYtr06Q2rbt3aJyasE2VeAYcOHXImyMzOpjDTEsmx6vcw8AqYk0h4LeZ3l4hIBCRycmRgzgRsvH79mi0xjFSAXDuunAtSZKsoBUhw5ylm3fr1JGfBDGdsAph0ZW4uh89ZbawOcKX6DxjAwL7k0Q8hrbYTtRLbwBacP38+Pgcys7JkcO4+vn//DhtxOMD1cgamK3I+TOVROnDo8GFhuzOwswUkhaUlgP1lIN9B5DisSBaQngBWJvdbHsVbtmyR1xjHsrKzKTY1AbK3csI5nFxNuYZSBF30C/A/ir10HVAUyEFOSwAtlI9c2/JWyZYUFxfz3XaIySN7GNFKI4TJWTGHT64kj2v+Xlxs9b7kO/DnLvD7DlBV1IiAZ6uBj/sRGUq/AxcmArsCYGeSz1c3IiD/FbC/m76JitNFdTHjaAdY+dGhLNLTAl54agTVUoh2pKoYKeH7OeMAi2NMtkEKqHGKuL3QWFeniGsztXpWxP9d9/C/Nxt5LZ3UCRnj0wEt5vQICBRQwBO4oQMeGWoCaUGC9m+7BC+q6gteJWPdAV0QuEoBS+ADKzg13CSz38k6KejOwrAzlKCAtooPQ081xTxfw95qXpxk2kOb2YqQuKrYKiAA9FY8jObDdsWugQSASYobzVxEC7pcvzlA7IFsJwD8XcqRQaxeiQAAAABJRU5ErkJggg==",
  "[BundleMaker] Sony":
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAe1BMVEUAAAAdGyBmZmeem6Dl5OXr6+zu7u7t7u22tLgtLS/c3NwHAwuurK////+WlZdQTVH7+vtVVVWgoKCSkpKSj5LZ1dn08/VycHWmpaYbGhzAvsLQztI9O0AWFxYSDhJMSVEoJC2GhYfx8fFkYmUKCgpsaW5IRklYVVrFxMXkx8jBAAAA0UlEQVR4Ad3PRYKEMBAF0I+EFijc3eH+JxychLlBv8iqFL9FkhWVMU1j7PWWP8CXMXB0QyUOMy2bCDeH0cr1Fn5AB9xoEUY4KeEjIKaFj1uSigEZLQzwUiFgHzDNC1xKYcg3HTLDUCpsTNe9AyISaYpXQ9DQU/iVwXOMlp5SiDrPzEig4NDHrldil7vGO6RDfwYQUYNbn/jav4BwAC9/Biw8cEZafCEEUGDiNDFadEKAvX1vxTTdY5kIfIBfxF/i2POIO6BlrQygi2a2e8sWfsofNV8Uq2sT9bQAAAAASUVORK5CYII=",
  "[BundleMaker] Vudu":
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAAE8klEQVR4Ab2UA5AsSRCG/6oe7Yu1d8+2bdu278J3wbMR5l3oGDibz7Ztm6tx73R34Sp7NdOzeP4jvnb+WVWZ1fyW7zY3nfvTjl9O+X1X+0m/72g/8Y+dhxTKQbku+GX7bzd9s7WZ72HsU6e8+mENXs15pNpi4UMK5aBcdmntgy0R/Rm3hb5ZpBJQOQfKzh0WKJdIxWFLdTOXSioIAJ6G9pSPcCScXCH0jN4Nzt7FUy4IQAsmuXahlavQg3QlolqjJsQKoECv20S5/dGXXHkqGE+e5F0Yo6TmWhSOPpEWeOikUkx+9EhMfKSPT66ooSBKMNjMDQrvXVpdEEteDxtP8i6IyWlw7cHcyF4sqbGpzUF5lKMy1scTZ5bjvNoIbJu+6x+7U+LsmgieP6eiIJa8NhpP8u77XkFLBa4DM4oqhRkbM1jZ4iCoG48dBtcR3ctdCD1zO4X5pgRBrTBe5BnVeTGu8M9cC2lu+uBSoT3pYfTqFIK6+YRSVIdYVy+4hdDyV4UZbjmxFEGNWpXyPblQBTEyJ8EpULkayusChpDUGLMiCaE08nVyXRQXNMZg2zT6vhi6pmfnN8Rwan0M+XKN12jjRZ6g7/NRGkVNqAwRrbFkq435W2zkizHg5pPLIB0FmVcGuqbmu8k0Gmco0NzNWSwzXuSpgo3rip4ByAKoDKmUhxHLEgjqplPK0FDC4Tmi93u6ro9x3HxaOYIasTSBTMYjz+LGdagHcqCRFNU0Co1xS+LIOhL5OrY2ikuOGYZspm9L2VmBS44uwfHmXb5SnRLjlsbJizyLETQARaPRRYS1xpptNqavSSOo286oAISCcqQPmd1KzwKaYhp53XYbYVXsT8DA4VLdi+FC+zMbPr+9eDuaZEeWhfxfrGtoLgvjpjMrEdR/89rh2BJM6H5zgEqAHDVDMcoQY8CExXG0pQTy1VgZwZUnlfllIK4y101VEeRrV9zF5CUJRBmgiv39+isqgZKi64FXTEhpbNphY8KSDgR1+3lV/ioxofzroMYujGPLrs7u5Vf94/T+CfuHzEVO4r9ZbQjqurMqcURFCM3lYf86qH9ntfjNDaH69VZ0Fh64dtF1MwAxDkxZ1IEte3LIV7Wp+yUnluFSs/drzCDytcY03owlcSphwC+AXwJFDaEHhMqwyyzlqNmtCOqxaxvw2HWNCGr4zFa0tORgKQzqrXKamlAC7iB42h/pf1NboDUKdNcVdbjr8jrkS0ptvt0DS2nAU4N7Cw0u/C0yGMovw2yzG1ZsTGMozV+VxMLl1P2MYgf1FlQCKAFINSghAB0dOQw3qzCU/pmyB+mECwt6SF+CYy9lhTiGT9sDqTQGUqejMHpGK8KRvbYFB7MAxoakJBbCgjUpTJzXjoE0c0kHVm3OIBLdO0+C+xfW0Fhh5vfUu1+sQ0uHi/40wsw+5yiEwnyvPAlucQa2F8BQWhrCvNVJ3PPaQvw2cTd2tDpIZAR2tjmYvKADI2a1IWa+wV56MouD7+1ICTIuKwtj/toUnvpoGS59aTbOe3YmLjHn+95ahB3tDmIxa+/9QJYW2OAjLYZWIhrj6Mh6aEm46Mh4EEBX8+29DyxLMY6wtJiF7hnuJcyvHSIRixrOP4dCfK/jKVdXTm1xK+yNDQ0rAwuHDZHDRBiUMxwR43gpc15h3u7fOXPjwOGBcjFv1x+xmHj5f6aKHPybnMVGAAAAAElFTkSuQmCC",
  "[BundleMaker] Microsoft":
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAIAAAD8GO2jAAAABnRSTlMAAAAAAABupgeRAAAAWklEQVR4AWP4FKBEJPrip8wABrV7GOp3EYtGhgWjFoxaMGrBqAXf/OSIRD995CEWVO9hqN1FLBoOYNlnotF3iI7/O4lHQOVL3hONPo9agB2NWjBqwagFoxYAAB2zMZ7bQW2tAAAAAElFTkSuQmCC",
  "[BundleMaker] HBO Pan Regional":
    "data:image/png;base64,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",
  "[BundleMaker] M7":
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAmVBMVEUAbrn////iBxMAbbjxAACjPGYAecsAeMp/T4P1AAAAb7oAbrgAYrQAZ7YAXbEAVa4AarcAW7Func6zyuQAU63b5/MAaLaTtNoAV64ATaqBqdSXud2Kr9dokchWiMRBer2rw+A4crrG1+vq8PhRgsH1+fzO3u5Zi8Xj6/XD0OcAR6iUudwAQKXw9fovbri50+mJtdo+gcEqeL1Athj8AAABd0lEQVQ4jYWT22LCIAyG07EjJAg9olZrPbtNd3j/hxuEVldv+t3wE35KEig8jACPI8DTCPA8AogeFRgIBnokWmtRekGdGCLdLMuyOQJg7UU1uXNIXCSeZQlgmqBmduBQyNFV7qPK1kEv9H8HtTsfKyznp/J1cGxRXdcNbThUovagYPuuLft14YqwPteYVp4UcRbmG93VqCZZmB91eUmYi3H7MO5dV+Ccw1tjs2jInCijCMVKW/FkNaFD0rEgXcegk0Apy42TWO1PR69O6xXKnA9JagTRHoPaHUiSfv/w3/3UJE1z5m2N8T24sD7n4Thv+PIHy2ncxb1Q1HapSeWioc9rGe9M4TamhlJ/HwufGMVA2nfb3yQfWApZIpIEjI273ajMVyFymmpSyujp/NqEqyM2syhqpEPB+/d2+CAm61g3ET+MpHBiaBCOC6swGnZo7t+caVPPjxG/YWxI3RtAoMf04219+OzVbeyf/csI8DoCvI0AY7//Hyl4In8f+KP0AAAAAElFTkSuQmCC",
  "[BundleMaker] M7_test_Fab":
    "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAMAAABEpIrGAAAAmVBMVEUAbrn////iBxMAbbjxAACjPGYAecsAeMp/T4P1AAAAb7oAbrgAYrQAZ7YAXbEAVa4AarcAW7Func6zyuQAU63b5/MAaLaTtNoAV64ATaqBqdSXud2Kr9dokchWiMRBer2rw+A4crrG1+vq8PhRgsH1+fzO3u5Zi8Xj6/XD0OcAR6iUudwAQKXw9fovbri50+mJtdo+gcEqeL1Athj8AAABd0lEQVQ4jYWT22LCIAyG07EjJAg9olZrPbtNd3j/hxuEVldv+t3wE35KEig8jACPI8DTCPA8AogeFRgIBnokWmtRekGdGCLdLMuyOQJg7UU1uXNIXCSeZQlgmqBmduBQyNFV7qPK1kEv9H8HtTsfKyznp/J1cGxRXdcNbThUovagYPuuLft14YqwPteYVp4UcRbmG93VqCZZmB91eUmYi3H7MO5dV+Ccw1tjs2jInCijCMVKW/FkNaFD0rEgXcegk0Apy42TWO1PR69O6xXKnA9JagTRHoPaHUiSfv/w3/3UJE1z5m2N8T24sD7n4Thv+PIHy2ncxb1Q1HapSeWioc9rGe9M4TamhlJ/HwufGMVA2nfb3yQfWApZIpIEjI273ajMVyFymmpSyujp/NqEqyM2syhqpEPB+/d2+CAm61g3ET+MpHBiaBCOC6swGnZo7t+caVPPjxG/YWxI3RtAoMf04219+OzVbeyf/csI8DoCvI0AY7//Hyl4In8f+KP0AAAAAElFTkSuQmCC",
};
